


























































import Vue from "vue";
import { Tutor } from "../types";

export default Vue.extend({
  props: {
    tutor: {
      type: Object as () => Tutor,
      required: true
    }
  },

  computed: {
      hasAnySocialLinks(): boolean {
      return Boolean(
        this.tutor.linkedin_url ||
          this.tutor.twitter_url ||
          this.tutor.facebook_url ||
          this.tutor.youtube_url
      );
    }
  }
});
